import { __assign, __read } from "tslib";
import { useMemo } from 'react';
import { logUserThemeChange, } from '../util/userSettingsTelemetry';
import { useHarmonyTheme } from './useHarmonyTheme';
/**
 * A hook that returns a function for updating the Harmony theme with a partial Harmony theme
 */
export var useUpdateHarmonyTheme = function () {
    var _a = __read(useHarmonyTheme(), 2), harmonyTheme = _a[0], setHarmonyTheme = _a[1];
    return useMemo(function () {
        return function (partialHarmonyTheme, eventName, telemetryParams) {
            var theme = __assign(__assign(__assign({}, harmonyTheme), partialHarmonyTheme), { lastModifiedTimeUtc: Date.now() });
            setHarmonyTheme(theme);
            logUserThemeChange(eventName, {
                id: theme.id,
                mode: theme.mode,
                preferHarmonyTheme: theme.preferHarmonyTheme,
            }, telemetryParams);
        };
    }, [harmonyTheme, setHarmonyTheme]);
};
//# sourceMappingURL=useUpdateHarmonyTheme.js.map